import { Styles } from '@chakra-ui/theme-tools';

const styles: Styles = {
  global: {
    '*': {
      _focusVisible: {
        outline: '0 !important',
      },
    },
    th: {
      fontWeight: 'normal',
      fontFamily: 'inter !important',
    },
  },
};

export default styles;
